<template>
<div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

    <h1> {{ tipo == 'decurso' ? 'Processos com Decurso de Prazo' : 'Processos com Prazo em aberto' }}</h1>
    <!-- <p>Tela descricao.</p> -->


    <div style="text-align: right; width: 100%;" class="mb-1">
        <span class="material-icons-outlined" style="color: #007BFF;">
            help
        </span>
    </div>
    <div style="text-align: right; width: 100%;" class="mb-5">
        <button type="button" class="btn btn-sm btn-light" style="margin-right: 12px; margin-right: 2px; width: 120px; cursor: pointer; border: solid lightgray 1px;">
            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Gerar Planilha</label>
        </button>

        <button type="button" class="btn btn-sm btn-light" style="margin-right: 12px; width: 100px; cursor: pointer; border: solid lightgray 1px;">
            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Imp<u>r</u>imir</label>
        </button>

        <button type="button" class="btn btn-sm btn-light" style="width: 100px; cursor: pointer; background-color: white; border: solid lightgray 1px;" @click="voltar" >
            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;"><u>V</u>oltar</label>
        </button>
    </div>


    <div class="form-container mt-4 mb-3">
        <div class="form-title">Filtrar por:</div>


        <div class="row">
            <div class="col-md-4 mb-2">
                <label for="rito_selecionado" class="form-label mt-2"><strong>Rito processo</strong></label>
                <select v-model="rito_selecionado" class="form-select mt-1">
                    <option value="">Todos</option>
                    <option v-for="rito in ritos" :key="rito.id" :value="rito.id">{{ rito.descricao }}</option>
                </select>
            </div>

            <div class="col-md-4 mb-2">
                <label for="grau_judcial" class="form-label mt-2"><strong>Grau Judicial</strong></label>
                <select v-model="grau_judicial_selecionado" class="form-select mt-1">
                    <option value="">Todos</option>
                    <option value="1_grau">1º Grau</option>
                    <option value="2_grau">2º Grau</option>
                </select>
            </div>

            <div class="col-md-4 mb-2">
                <label for="cidade_selecionada" class="form-label mt-2"><strong>Localidade Judicial</strong></label>
                <select v-model="cidade_selecionada" class="form-select mt-1">
                    <option value="">Todos</option>
                    <option v-for="cidade in cidades" :key="cidade" :value="cidade.id">{{ cidade.descricao }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 mb-2">
                <label for="evento_intimacao_selecionado" class="form-label mt-2"><strong>Eventos de intimação</strong></label>
                    <select v-model="evento_intimacao_selecionado" class="form-select mt-1">
                        <option value="">Todos</option>
                        <!-- Eventos de Intimação Comuns -->
                        <option value="publicacao_diario_justica">Publicação no Diário de Justiça Eletrônico</option>
                        <option value="intimacao_eletronica">Intimação Eletrônica (Portal)</option>
                        <option value="citacao_oficial_justica">Citação/Intimação por Oficial de Justiça</option>
                        <option value="intimacao_carta_ar">Intimação por Carta (AR/MP)</option>
                        <option value="vista_mp_dp">Vista ao Ministério Público / Defensoria Pública</option>
                        <option value="intimacao_audiencia">Intimação para Audiência</option>
                        <option value="intimacao_manifestacao">Intimação para Manifestação/Contestação</option>
                        <option value="intimacao_pagamento">Intimação para Pagamento/Cumprimento de Sentença</option>
                        <option value="intimacao_juntada_documentos">Intimação sobre Juntada de Documentos/Provas</option>
                        <option value="intimacao_pericia">Intimação sobre Perícia/Nomeação de Perito</option>
                        <option value="intimacao_sentenca_acordao">Intimação de Sentença / Acórdão</option>
                        <option value="intimacao_decisao_interlocutoria">Intimação de Decisão Interlocutória/Despacho</option>
                        <option value="intimacao_edital">Intimação por Edital</option>
                        <option value="intimacao_ciencia_recurso">Intimação para Ciência de Recurso Interposto</option>
                    </select>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 mb-2">
                <label for="periodo_inicial" class="form-label mt-2"><strong>Período:</strong></label>
                <div style="display: flex; gap: 10px;">
                    <input type="date" class="form-control mt-1" v-model="periodo_inicial" />
                    <input type="date" class="form-control mt-1" v-model="periodo_final" />
                </div>
            </div>
        </div>

        <div class="row">
            <div style="text-align: right; width: 100%;" class="mb-2 mt-1">
                <button type="button" class="btn btn-sm btn_azul" @click="buscar">
                    <label  class="btn_azul_lbl">Filtrar</label>
                </button>
            </div>
        </div>
    </div>



    <div class="form-container mb-3">
        <p style="font-size: small; color: gray; text-align: right;">
            Lista de Citações e Intimações com Decurso de Prazo ({{ processos.length }} registros):
        </p>

        <table class="table table-striped table-bordered mt-2 border">
            <thead>
                <tr class="text-center">
                    <th scope="col" style="background-color: lightgrey;">Processo</th>
                    <th scope="col" style="background-color: lightgrey;">Classe</th>
                    <th scope="col" style="background-color: lightgrey;">Assunto</th>
                    <th scope="col" style="background-color: lightgrey;">Evento e Prazo</th>
                    <th scope="col" style="background-color: lightgrey;">Data envio requisição</th>
                    <th scope="col" style="background-color: lightgrey;">Final Prazo</th>
                    <th scope="col" style="background-color: lightgrey;">Conferido</th>
                </tr>
            </thead>
<tbody>
    <!-- Linha quando não há registros -->
    <tr v-if="processos.length === 0">
        <td colspan="7" class="text-center" style="font-size: small; color: gray;">
            Nenhum registro encontrado para os filtros selecionados.
        </td>
    </tr>

    <!-- Linhas com processos -->
    <tr v-for="proc in processos" :key="proc.id">
        <!-- PROCESSO + Requerente x Requerido -->
        <td style="text-align: center; font-size: small;">
            <strong><a target="_blank" :href='BASE_URL+"processos/movimentacao_processual/"+proc.id'>{{ proc.codigo_processo }}</a></strong>

            <br />

            <small v-if="getRequerente(proc) || getRequerido(proc)">
                <strong>Requerente:</strong>
                <br />
                {{ getRequerente(proc) || '---' }}
                <span v-if="getRequerido(proc)">
                    <br />
                    X 
                    <br />
                    <strong>Requerido:</strong>
                    <br />
                    {{ getRequerido(proc) }}
                </span>
            </small>
        </td>

        <!-- CLASSE PROCESSUAL -->
        <td style="text-align: left; font-size: small;">
            {{ proc.classe_processual ? proc.classe_processual.descricao : '' }}
        </td>

        <!-- ASSUNTOS -->
        <td style="text-align: left; font-size: small;">
            <span
                v-for="(assunto, i) in proc.assuntos"
                :key="assunto.id || i"
            >
                - {{ assunto.descricao || ('Assunto #' + (i + 1)) }}
                <span v-if="i < proc.assuntos.length - 1">;<br /></span>
            </span>
        </td>

        <!-- EVENTO E PRAZO (lista de petições do processo) -->
        <td style="text-align: left; font-size: small;">
            <ul style="padding-left: 1rem; margin-bottom: 0;">
                <li
                    v-for="(pet, idx) in proc.peticoes"
                    :key="pet.id"
                    style="list-style-type: disc;"
                >
                    <!-- Tipo da petição + descrição -->
                    <strong>{{ pet.tipo?.descricao || 'Petição' }}</strong>
                    <span v-if="pet.descricao"> — {{ pet.descricao }}</span>

                    <!-- Prazo da petição -->
                    <span v-if="pet.prazo">
                        &nbsp; | Prazo: {{ formatDateSemHora(pet.prazo) }}
                    </span>
                </li>
            </ul>
        </td>

        <!-- DATA ENVIO REQUISIÇÃO (petição em foco) -->
        <td style="text-align: center; font-size: small;">
            <span v-if="peticaoEmFoco(proc)">
                {{ formatDateSemHora(peticaoEmFoco(proc).created_at) }}
            </span>
        </td>

        <!-- FINAL PRAZO (petição em foco) -->
        <td style="text-align: center; font-size: small;">
            <span v-if="peticaoEmFoco(proc) && peticaoEmFoco(proc).prazo">
                {{ formatDateSemHora(peticaoEmFoco(proc).prazo) }}
            </span>
        </td>

        <!-- CONFERIDO (mantém como está por enquanto) -->
        <td style="text-align: center;">
            <span v-if="true">✔</span>
            <!-- <span v-else>✖</span> -->
        </td>
    </tr>
</tbody>
        </table>
    </div>

      
</div>
</template>
  
  <script>
  
  export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            rito_selecionado: '', 
            ritos: [],
            cidade_selecionada: '', 
            cidades: [],
            grau_judicial_selecionado: '',
            evento_intimacao_selecionado: '',
            periodo_inicial: '',
            periodo_final: '',
            processos: [],
        };
  },
  
  props: {
        user: {
            type: Object,
            required: true,
        },
        tipo: {        // vem do Blade: 'abertos' ou 'decurso'
            type: String,
        }
    },
    methods: {


        voltar() {
            //this.$router.back();
            console.log('clicou no voltar');
            window.location.href = this.BASE_URL + "home";
        },

        peticaoEmFoco(proc) {
            if (!proc.peticoes || !proc.peticoes.length) return null;

            // escolhe a petição com menor prazo (mais próxima)
            const comPrazo = proc.peticoes.filter(p => p.prazo);

            if (!comPrazo.length) {
                // fallback: se nenhuma tiver prazo, devolve a primeira mesmo
                return proc.peticoes[0];
            }

            return comPrazo.reduce((maisProxima, atual) => {
                const prazoMaisProxima = new Date(maisProxima.prazo);
                const prazoAtual = new Date(atual.prazo);
                return prazoAtual < prazoMaisProxima ? atual : maisProxima;
            });
        },
        formatDateSemHora(value) {
            if (value) {
                const date = new Date(value);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
                const year = date.getFullYear();
                //const hours = date.getHours().toString().padStart(2, '0');
                //const minutes = date.getMinutes().toString().padStart(2, '0');
                //const seconds = date.getSeconds().toString().padStart(2, '0');
                return `${day}/${month}/${year}`;
            }
            return '';
        },
        getRequerente(proc) {
            if (!proc.partes) return null;

            // tenta achar parte com polo_ativo = 1 (ou true)
            const parte = proc.partes.find(
                (p) => p.pivot && p.pivot.polo_ativo
            );

            return parte ? parte.nome : null;
        },

        getRequerido(proc) {
            if (!proc.partes) return null;

            // tenta achar parte com polo_passivo = 1
            const parte = proc.partes.find(
                (p) => p.pivot && p.pivot.polo_passivo
            );

            return parte ? parte.nome : null;
        },

        // devolve a primeira petição com prazo (elas já vêm ordenadas por prazo no backend)
        primeiraPeticao(proc) {
            if (!proc.peticoes || !proc.peticoes.length) return null;
            return proc.peticoes[0];
        },

        CarregarDados(dados_carregar){
            axios.get(this.BASE_URL + 'buscar/dados_iniciais/' + dados_carregar)
            .then(response => {
                if(dados_carregar == 'cidades'){
                    this.cidades = response.data;
                }
                else if(dados_carregar == 'ritos'){
                    this.ritos = response.data;
                }
            })
            .catch(error => {
                console.error('Erro ao buscar informações da '+dados_carregar+':', error);
            });
        },
        
        CarregarCidades(){
            this.CarregarDados('cidades');
        },
        CarregarRitos(){
            this.CarregarDados('ritos');
        },
        buscar() {
            const params = {
                rito_id: this.rito_selecionado || null,
                grau_judicial: this.grau_judicial_selecionado || null,
                cidade_id: this.cidade_selecionada || null,
                evento_intimacao: this.evento_intimacao_selecionado || null,
                periodo_inicial: this.periodo_inicial || null,
                periodo_final: this.periodo_final || null,
            };

            let url = this.BASE_URL;
            if (this.tipo === 'abertos') {
                url += 'processos_prazos_abertos';
            } else if (this.tipo === 'decurso') {
                url += 'processos_decurso_prazo';
            } else {
                console.error('Tipo inválido recebido no componente:', this.tipo);
                return;
            }

            axios.get(url, { params })
                .then(response => {
                    console.log(response.data.data);
                    this.processos = response.data.data;
                })
                .catch(error => {
                    console.error('Erro ao buscar processos:', error);
                });
        },

        formatarData(valor) {
            if (!valor) return '';
            // se vier "2025-12-01 10:30:00"
            const data = new Date(valor);
            if (isNaN(data.getTime())) return valor; // se não der parse, mostra como veio
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            const hora = String(data.getHours()).padStart(2, '0');
            const min = String(data.getMinutes()).padStart(2, '0');
            return `${dia}/${mes}/${ano} ${hora}:${min}`;
        }
    },
    mounted() {
        this.CarregarRitos();
        this.CarregarCidades();
        this.buscar();
    },

    
  };
</script>

<style scoped>
h1{
    font-size: 26px;
}

.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;
}

.btn_azul{
    margin-right: 3px; 
    width: 90px; 
    cursor: pointer; 
    background-color: #007BFF;
}

.btn_azul_lbl{
    color: white; 
    vertical-align: middle; 
    cursor: pointer;
}
</style>
  
